(function() {
    'use strict';

    angular.module('app.archivoAsociacion', []);
})();
